const config = {
  columns: [
    {
      dataIndex: 'orgId',
      hidden: true,
    },
    {
      title: '序号',
      width: 80,
      render: 'numberRender',
    },
    {
      title: '报价类型',
      dataIndex: 'quoteTypeName',
      width: 150,
    },
    {
      title: '合同标题',
      dataIndex: 'title',
      width: 150,
    },
    {
      title: '顺序',
      dataIndex: 'priority',
      width: 80,
    },
    {
      title: '适用门店',
      dataIndex: 'orgName',
      width: 150,
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 120,
      render: 'startDateRender',
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 120,
      render: 'endDateRender',
    },
    {
      title: '操作',
      render: 'actionTool',
      fixed: 'right',
      width: 150,
    },
  ],
  search: [
    {
      name: 'quoteType',
      label: '报价类型',
      data: 'budgetList',
      itemType: 'select',
      labelKey: 'name',
      key: 'code',
    },
  ],
  footer: [
    { label: '下载导入模板', render: 'downloadRender' },
    { label: '批量导入', render: 'importRender' },
    { label: '导出', render: 'exportRender' },
    { label: '添加配置', type: 'primary', events: ['onClick:addConfig'] },
  ],
  batchActions: [
    {
      label: '批量删除',
      danger: true,
      events: ['onClick:batchDelete'],
    },
  ],
}

export default config
